// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d48eedb1","455":"3d27ffa6","977":"bff9cbec"}[chunkId] + ".chunk.js";
};